import { useState, useRef } from "react";
import { Calendar, Newspaper, ExternalLink, RefreshCw } from "lucide-react";

// Live TransAsia pages — opened externally via the header button.
const EVENTS_URL = "https://transasia.co.in/events";
const NEWS_URL = "https://transasia.co.in/article/news";
// First-party proxy so the listing renders inside the in-app webview
// (the live site needs a country cookie that Safari blocks in a 3rd-party iframe).
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export default function InsightsPage() {
  const [tab, setTab] = useState("events");
  const [reloadKey, setReloadKey] = useState(0);
  const iframeRef = useRef(null);

  const url = `${BACKEND}/api/insights/proxy?kind=${tab === "events" ? "events" : "news"}`;
  const externalUrl = tab === "events" ? EVENTS_URL : NEWS_URL;

  const switchTab = (t) => { if (t !== tab) { setTab(t); setReloadKey(k => k + 1); } };
  const refresh = () => setReloadKey(k => k + 1);

  return (
    <div className="flex flex-col h-[calc(100vh-9rem)]" data-testid="insights-page">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-xl font-bold text-gray-900">News & Events</h1>
        <div className="flex items-center gap-2">
          <button
            onClick={refresh}
            className="p-2 rounded-lg text-gray-500 hover:bg-gray-100"
            title="Refresh"
            data-testid="insights-refresh-btn"
          >
            <RefreshCw className="w-4 h-4" />
          </button>
          <a
            href={externalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 rounded-lg text-gray-500 hover:bg-gray-100"
            title="Open in browser"
            data-testid="insights-open-external-btn"
          >
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="flex gap-2 mb-3">
        <button
          onClick={() => switchTab("events")}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
            tab === "events" ? "bg-[#008A99] text-white" : "bg-gray-100 text-gray-600"
          }`}
          data-testid="events-tab"
        >
          <Calendar className="w-4 h-4" /> Events
        </button>
        <button
          onClick={() => switchTab("news")}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
            tab === "news" ? "bg-[#008A99] text-white" : "bg-gray-100 text-gray-600"
          }`}
          data-testid="news-tab"
        >
          <Newspaper className="w-4 h-4" /> News
        </button>
      </div>

      <div className="flex-1 rounded-2xl overflow-hidden border border-slate-200 bg-white shadow-sm">
        <iframe
          ref={iframeRef}
          key={`${tab}-${reloadKey}`}
          src={url}
          title={tab === "events" ? "TransAsia Events" : "TransAsia News"}
          className="w-full h-full"
          loading="lazy"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation-by-user-activation"
          data-testid="insights-webview"
        />
      </div>
    </div>
  );
}
